import SupportContacts from '../components/SupportContacts';

/**
 * Help (`/chat/support`) and the old order chat (`/chat`), on InGo (Rio,
 * 2 Oct 2026: support chat becomes contact buttons). The old system's chat
 * ran on its own database, and its order chat showed sample messages; InGo
 * has the office's numbers from Settings instead, and a delivery's screen
 * carries the other person's number while the job is live.
 *
 * @param {{ support?: boolean }} props
 */
export default function ChatPage({ support = false }) {
  return (
    <SupportContacts
      note={
        support
          ? ''
          : "To reach your rider or your client about a delivery, use Call on the delivery's own screen while it is under way."
      }
    />
  );
}
